<template>
    <div data-backdrop="static" data-keyboard="false" class="modal fade" id="withdrawal-point-form-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title page-title" v-html="modalTitle"/>
                </div>
                <form @submit.prevent="submit()" class="form-horizontal">
                    <div class="modal-body">
                        <div class="row form-group mb-4">
                            <label class="col-1 control-label" for="withdrawal-point-name">
                                <span v-html="$t('WithdrawalPointFormModal.name')"/>
                                <RedAsterisk/>
                            </label>
                            <div class="col-11">
                                <input class="form-control" required id="withdrawal-point-name" v-model="withdrawalPoint.name"
                                       :placeholder="$t('WithdrawalPointFormModal.required')" ref="NameInput"/>
                            </div>
                        </div>
                        <hr class="mt-2"/>
                        <div class="row justify-content-center mb-2">
                            <h4 class="page-title">
                                <i class="fa fa-map-pin mr-2 text-distribution"/>
                                <span v-html="$t('WithdrawalPointFormModal.postalAddress')"/>
                            </h4>
                        </div>
                        <div class="row form-group">
                            <label class="col-6 control-label" for="withdrawal-point-street">
                                <span v-html="$t('WithdrawalPointFormModal.street')"/>
                                <RedAsterisk/>
                            </label>
                            <label class="col-6 control-label" for="withdrawal-point-street-bis">
                                <span v-html="$t('WithdrawalPointFormModal.streetBis')"/>
                            </label>
                            <div class="col-6">
                                <input class="form-control" required id="withdrawal-point-street" v-model="withdrawalPoint.address.street"
                                       :placeholder="$t('WithdrawalPointFormModal.required')"/>
                            </div>
                            <div class="col-6">
                                <input class="form-control" id="withdrawal-point-street-bis" v-model="withdrawalPoint.address.streetBis"
                                       :placeholder="$t('WithdrawalPointFormModal.optional')"/>
                            </div>
                        </div>
                        <div class="row form-group">
                            <label class="col-4 control-label" for="withdrawal-point-zip-code">
                                <span v-html="$t('WithdrawalPointFormModal.zipCode')"/>
                                <RedAsterisk v-if="!isZipCodeOptional"/>
                            </label>
                            <label class="col-4 control-label" for="withdrawal-point-city">
                                <span v-html="$t('WithdrawalPointFormModal.city')"/>
                                <RedAsterisk/>
                            </label>
                            <label class="col-4 control-label">
                                <span v-html="$t('WithdrawalPointFormModal.country')"/>
                                <RedAsterisk/>
                            </label>
                            <div class="col-4">
                                <input class="form-control" id="withdrawal-point-zip-code" v-model="withdrawalPoint.address.zipCode"
                                       :placeholder="withdrawalPointZipCodePlaceholder" :required="!isZipCodeOptional"/>
                            </div>
                            <div class="col-4">
                                <input class="form-control" required id="withdrawal-point-city" v-model="withdrawalPoint.address.city"
                                       :placeholder="$t('WithdrawalPointFormModal.required')"/>
                            </div>
                            <div class="col-4">
                                <CountrySelect :selected-country-alpha3="withdrawalPoint.address.country.iso"
                                                @setSelectedCountry="setSelectedCountry"/>
                            </div>
                        </div>
                        <hr class="mt-2"/>
                        <div class="row justify-content-center mb-2">
                            <h4 class="page-title">
                                <i class="fa fa-money-bill-wave mr-2 text-distribution"/>
                                <span v-html="$t('WithdrawalPointFormModal.billingMethod')"/>
                            </h4>
                        </div>
                        <div class="row form-group">
                            <label class="col-4 control-label" for="withdrawal-point-price-w-t">
                                <span v-html="$t('WithdrawalPointFormModal.priceWT')"/>
                                <RedAsterisk/>
                            </label>
                            <label class="col-4 control-label" for="withdrawal-point-currency">
                                <span v-html="$t('WithdrawalPointFormModal.currency')"/>
                                <RedAsterisk/>
                            </label>
                            <label class="col-4 control-label" for="withdrawal-point-charged-by">
                                <span v-html="$t('WithdrawalPointFormModal.chargedBy')"/>
                                <RedAsterisk/>
                            </label>
                            <div class="col-4">
                                <input class="form-control" id="withdrawal-point-price-w-t" v-model="withdrawalPoint.priceWT"
                                       :placeholder="$t('WithdrawalPointFormModal.required')" required type="number"
                                       min="0" step="0.01"/>
                            </div>
                            <div class="col-4">
                                <CurrencySelect id="withdrawal-point-currency" :selected-currency-alpha3="withdrawalPoint.currency"
                                                @setSelectedCurrency="setSelectedCurrency"/>
                            </div>
                            <div class="col-4">
                                <select class="form-control" id="withdrawal-point-charged-by" v-model="withdrawalPoint.chargedBy">
                                    <option value="order" v-html="$t('WithdrawalPointFormModal.byOrder')"/>
                                    <option value="product" v-html="$t('WithdrawalPointFormModal.byProduct')"/>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer flex justify-content-between">
                        <button :disabled="loading" type="button" class="btn btn-secondary" data-dismiss="modal" v-html="$t('WithdrawalPointFormModal.close')"/>
                        <SubmitBtn classes="btn btn-primary" :text="modalMainAction" :loading="loading"/>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SubmitBtn from "../../forms/SubmitBtn";
import WithdrawalPoint from "../../../../classes/Distribution/WithdrawalPoint";
import CountrySelect from "../../forms/CountrySelect";
import CurrencySelect from "../../forms/CurrencySelect";
import RedAsterisk from "../../forms/RedAsterisk";

export default {
    name: "WithdrawalPointFormModal",
    components: {RedAsterisk, CurrencySelect, CountrySelect, SubmitBtn },
    data() {
        return {
            loading: false,
            mode: "create",
            withdrawalPoint: new WithdrawalPoint(),
        };
    },
    computed: {
        ...mapGetters("hermesAPIConfig", {
            hermesShop: "shop",
            isZipCodeOptional: "isZipCodeOptional",
        }),
        modalTitle() {
            return this.mode === "create" ? this.$t("WithdrawalPointFormModal.addWithdrawalPoint") : this.$t("WithdrawalPointFormModal.editWithdrawalPoint");
        },
        modalMainAction() {
            return this.mode === "create" ? this.$t("WithdrawalPointFormModal.add") : this.$t("WithdrawalPointFormModal.edit");
        },
        withdrawalPointZipCodePlaceholder() {
            return this.isZipCodeOptional ? this.$t("WithdrawalPointFormModal.optional") : this.$t("WithdrawalPointFormModal.required");
        },
    },
    methods: {
        show(withdrawalPoint = null) {
            this.mode = withdrawalPoint === null ? "create" : "edit";
            this.withdrawalPoint = new WithdrawalPoint(withdrawalPoint);
            // eslint-disable-next-line no-undef
            $("#withdrawal-point-form-modal").modal("show");
            if (this.mode === "create") {
                setTimeout(() => this.$refs.NameInput.focus(), 500);
                this.withdrawalPoint.chargedBy = "order";
            }
        },
        async submit() {
            try {
                this.loading = true;
                this.sanitizeForAPI();
                if (this.mode === "create") {
                    await this.submitCreate();
                } else if (this.mode === "edit") {
                    await this.submitEdit();
                }
            } catch (e) {
                this.$displayError(e);
            } finally {
                this.loading = false;
            }
        },
        async submitCreate() {
            const { data } = await this.$hermesAPI.postWithdrawalPoint(this.withdrawalPoint);
            this.$emit("addWithdrawalPoint", data);
            // eslint-disable-next-line no-undef
            $("#withdrawal-point-form-modal").modal("hide");
            this.$toasted.success(this.$t("WithdrawalPointFormModal.withdrawalPointAdded"), { icon: "check" });
        },
        async submitEdit() {
            const { data } = await this.$hermesAPI.patchWithdrawalPoint(this.withdrawalPoint);
            this.$emit("editWithdrawalPoint", data);
            // eslint-disable-next-line no-undef
            $("#withdrawal-point-form-modal").modal("hide");
            this.$toasted.success(this.$t("WithdrawalPointFormModal.withdrawalPointEdited"), { icon: "check" });
        },
        setSelectedCountry(country) {
            this.withdrawalPoint.address.country.iso = country.alpha3ISO;
            this.withdrawalPoint.address.country.name = country.name;
        },
        setSelectedCurrency(currency) {
            this.withdrawalPoint.currency = currency.alpha3ISO;
        },
        sanitizeForAPI() {
            if (typeof this.withdrawalPoint.address.zipCode === "string" && !this.withdrawalPoint.address.zipCode.trim()) {
                this.withdrawalPoint.address.zipCode = null;
            }
        },
    },
};
</script>

<style scoped>

</style>